/* ==========================================================================
   MONA CARDS — product card swatch interaction (global, event-delegated)
   Clicking a swatch updates the card's main image without navigating.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__monaCardsInit) return;
  window.__monaCardsInit = true;

  document.addEventListener('click', function (e) {
    var swatch = e.target.closest('[data-swatch]');
    if (!swatch) return;
    e.preventDefault();

    var card = swatch.closest('[data-product-card]');
    if (!card) return;

    // active state
    card.querySelectorAll('[data-swatch]').forEach(function (s) { s.classList.remove('is-active'); });
    swatch.classList.add('is-active');

    // swap image if the swatch carries a variant image
    var src = swatch.getAttribute('data-variant-img');
    if (src) {
      var img = card.querySelector('[data-card-media] img');
      if (img) {
        img.src = src;
        img.removeAttribute('srcset');
      }
    }
  });
})();
